import { render, staticRenderFns } from "./AreaIndicator.vue?vue&type=template&id=6b4019f0&scoped=true"
import script from "./AreaIndicator.vue?vue&type=script&lang=ts"
export * from "./AreaIndicator.vue?vue&type=script&lang=ts"
import style0 from "./AreaIndicator.vue?vue&type=style&index=0&id=6b4019f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4019f0",
  null
  
)

export default component.exports